<template>
    <AdminLayout>
        <section class="grid grid-cols-7">
            <div class="col-span-5 py-2 px-10">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between mb-8">
                            <p class="font-semibold text-xl text-neutral-800">View Employee Details</p>
                        </div>

                        <div class="grid grid-cols-2 gap-x-10 gap-y-7">
                            <!-- <div class="flex items-start border-b border-neutral-300 space-x-1 col-span-2">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Role:</span>
                                <p class="input-label">{{empdata}}</p>
                            </div> -->
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">First Name:</span>
                                <p class="input-label">{{empdata.fname}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Last Name:</span>
                                <p class="input-label">{{empdata.lname}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Gender:</span>
                                <p class="input-label">{{empdata.gender ? empdata.gender : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Date of Birth:</span>
                                <p class="input-label">{{empdata.dob ? formatDate(empdata.dob) : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Country:</span>
                                <p class="input-label">{{empdata.country ? empdata.country : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Marital Status:</span>
                                <p class="input-label">{{empdata.married ? empdata.married : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Email:</span>
                                <p class="input-label">{{empdata.email ? empdata.email : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Phone:</span>
                                <p class="input-label">{{empdata.phone ? empdata.phone : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Employee Id:</span>
                                <p class="input-label">{{empdata.empid ? empdata.empid : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Job Title:</span>
                                <p class="input-label">{{empdata.jobtitle ? empdata.jobtitle : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Department:</span>
                                <p class="input-label">{{empdata.dept ? empdata.dept : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Designation:</span>
                                <p class="input-label">{{empdata.designation ? empdata.designation : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Date of Joining:</span>
                                <p class="input-label">{{empdata.doj ? formatDate(empdata.doj) : 'Not Added'}}</p>
                            </div>
                            <!-- <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Reporting Manager:</span>
                                <p class="input-label">{{empdata.reporting_manager ? empdata.reporting_manager : 'Not Added'}}</p>
                            </div> -->
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Gross Salary:</span>
                                <p class="input-label">{{empdata.gross_salary ? empdata.gross_salary : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Bank Account Number:</span>
                                <p class="input-label">{{empdata.acc_number ? empdata.acc_number : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">PAN Number:</span>
                                <p class="input-label">{{empdata.pan ? empdata.pan : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Job Experience</span>
                                <p class="input-label">{{empdata.jobexperience ? empdata.jobexperience+' year' : 'Not Added'}}</p>
                            </div>
                            <div v-if="empdata.benifitdoc">
                                <table class="w-full text-sm text-left text-neutral-500 min-w-[322px]">
                                    <thead class="text-xs text-neutral-600 uppercase bg-slate-100">
                                        <tr>
                                            <th class="text-[11px] leading-none p-2 font-semibold">Uploaded Benifit Related Documents</th>
                                            <th class="text-[11px] leading-none p-2 font-semibold text-right">View Document</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-2 text-xs font-normal">
                                                <p class="">{{empdata.benifitdoc}}</p>
                                            </td>
                                            <td class="px-2 py-2 text-xs font-normal text-right">
                                                <a :href="`${assetURL}media/benifitDocument/${empdata.benifitdoc}`" class="block w-fit rounded-lg p-1 text-blue-600 bg-blue-100 ml-auto" target="_blank">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="empdata.edu_certificate">
                                <table class="w-full text-sm text-left text-neutral-500 min-w-[322px]">
                                    <thead class="text-xs text-neutral-600 uppercase bg-slate-100">
                                        <tr>
                                            <th class="text-[11px] leading-none p-2 font-semibold">Uploaded Highest Educational Certificate:</th>
                                            <th class="text-[11px] leading-none p-2 font-semibold text-right">View Document</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-2 text-xs font-normal">
                                                <p class="">{{empdata.edu_certificate}}</p>
                                            </td>
                                            <td class="px-2 py-2 text-xs font-normal text-right">
                                                <a :href="`${assetURL}media/educationCertificate/${empdata.edu_certificate}`" class="block w-fit rounded-lg p-1 text-blue-600 bg-blue-100 ml-auto" target="_blank">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Highest Education Level:</span>
                                <p class="input-label">{{empdata.}}</p>
                            </div> -->
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">School/Institution Name:</span>
                                <p class="input-label">{{empdata.edu_institue ? empdata.edu_institue : 'Not Added'}}</p>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Relevent skills:</span>
                                <div class="flex overflow-x-auto">
                                    <div v-if="empdata.emp_skills" class="flex overflow-x-auto">
                                        <div class="bg-blue-400 rounded-full px-2.5 uppercase py-1 text-xs text-whute text-white m-0.5" v-for="(skill, index) in empdata.emp_skills" :key="index">{{skill}}</div>        
                                    </div>    
                                    <div v-else>
                                        <p class="input-label">No Skills Added</p>
                                    </div>                        
                                </div>
                            </div>
                            <div v-if="empdata.experience_certificate">
                                <table class="w-full text-sm text-left text-neutral-500 min-w-[322px]">
                                    <thead class="text-xs text-neutral-600 uppercase bg-slate-100">
                                        <tr>
                                            <th class="text-[11px] leading-none p-2 font-semibold">Uploaded Certificates:</th>
                                            <th class="text-[11px] leading-none p-2 font-semibold text-right">View Document</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-2 text-xs font-normal">
                                                <div class="text-[11px] leading-none p-2 font-semibold text-right">{{empdata.experience_certificate}}</div>
                                            </td>
                                            <td class="px-2 py-2 text-xs font-normal text-right">
                                                <a :href="`${assetURL}media/experienceCertificate/${empdata.experience_certificate}`" class="block w-fit rounded-lg p-1 text-blue-600 bg-blue-100 ml-auto" target="_blank">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1 col-span-2">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Previous Employer:</span>
                                <p class="input-label">
                                    {{empdata.prev_employer ? empdata.prev_employer : 'Not Added'}}
                                </p>
                            </div>
                            
                            <div class="flex items-start border-b border-neutral-300 space-x-1" v-if="empdata.emp_cv">
                                <table class="w-full text-sm text-left text-neutral-500 min-w-[322px]">
                                    <thead class="text-xs text-neutral-600 uppercase bg-slate-100">
                                        <tr>
                                            <th class="text-[11px] leading-none p-2 font-semibold">Uploaded CV:</th>
                                            <th class="text-[11px] leading-none p-2 font-semibold text-right">View Document</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-2 text-xs font-normal">
                                                <p class="">{{empdata.emp_cv}}</p>
                                            </td>
                                            <td class="px-2 py-2 text-xs font-normal text-right">
                                                <a :href="`${assetURL}media/cv/${empdata.emp_cv}`" class="block w-fit rounded-lg p-1 text-blue-600 bg-blue-100 ml-auto" target="_blank">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="flex items-start border-b border-neutral-300 space-x-1" v-if="empdata.emp_id_doc">
                                <table class="w-full text-sm text-left text-neutral-500 min-w-[322px]">
                                    <thead class="text-xs text-neutral-600 uppercase bg-slate-100">
                                        <tr>
                                            <th class="text-[11px] leading-none p-2 font-semibold">Uploaded ID Proof:</th>
                                            <th class="text-[11px] leading-none p-2 font-semibold text-right">View Document</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-2 text-xs font-normal">
                                                <div class="text-[11px] leading-none p-2 font-semibold text-right">{{empdata.emp_id_doc}}</div>
                                            </td>
                                            <td class="px-2 py-2 text-xs font-normal text-right">
                                                <a :href="`${assetURL}media/idProof/${empdata.emp_id_doc}`" class="block w-fit rounded-lg p-1 text-blue-600 bg-blue-100 ml-auto" target="_blank">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg>
                                                </a>
                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="border-b border-neutral-300 space-x-1 col-span-2"> 
                                <span class="shrink-0 pb-2 text-black text-sm font-normal mb-1">Shift Details:</span>
                                <table class="w-full text-sm text-left text-neutral-500 min-w-[322px]">
                                    <thead class="text-xs text-neutral-600 uppercase bg-slate-200">
                                        <tr>
                                            <th class="text-[11px] leading-none p-2 font-semibold">Name</th>
                                            <th class="text-[11px] leading-none p-2 font-semibold">Form Date</th>
                                            <th class="text-[11px] leading-none p-2 font-semibold">To Date</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="rosterDetails.length > 0">
                                        <tr v-for="(roster, index) in rosterDetails" :key="index">
                                            <td class="px-2 py-2 text-xs font-normal">
                                                <p class="truncate ">{{roster.rosterName}}</p>
                                            </td>
                                            <td class="px-2 py-2 text-xs font-normal">{{roster.effectiveFrom}}</td>
                                            <td class="px-2 py-2 text-xs font-normal">{{roster.effectiveTo}}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr class="bg-white border-b">
                                            <td class="px-2 py-2 text-xs font-normal" colspan="3">Roster Not Assigned</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        
                    </div>
                </div>    
            </div>
            <!-- <RightSideBar /> -->
        </section>
    </AdminLayout>
</template>

<script>
    import AdminLayout from '../AdminDashboard/AdminLayout.vue';
    // import RightSideBar from '../../components/RightSideBar.vue';
    import { BASE_URL } from "../../config";
    import { BASE_URL_POP } from '../../config';
    import axios from "axios";
    import moment from 'moment';

    export default {
        name: 'LeaveListing',
        components: {
            AdminLayout,
            // RightSideBar,
        },
        data() {
            return {
                url_data: '',
                empdata: [],
                assetURL: BASE_URL_POP,
                rosterDetails: [],
                globalDateFormat: '',
            };
        },
        methods: {
            async getEmployeeDetails() {
                try {
                    const response = await axios.post(BASE_URL + '/fetch-emp-details', { empid: this.url_data, view: 'view'});
                    console.log("Employee Details Response:", response.data);

                    if (response.data.formdetails !== false) {
                        this.empdata = response.data.empDetails;                    
                        this.empdata.emp_skills = response.data.empDetails.emp_skills.split(',');
                        this.rosterDetails = response.data.rosterData;
                    }
                } catch (error) {
                    console.error("Error fetching employee details:", error);
                }
            },

            formatDate(date) {
                if (!date) return '';
                return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
            },
        },
        created() {
            this.url_data = this.$route.params.slug;
            console.log("URL Data:", this.assetURL);
            this.getEmployeeDetails();
            this.globalDateFormat = localStorage.getItem("globalDateFormat");
        },        

    }
</script>

<style scoped>
/* Remove default input focus */
input:focus {
    outline: none;
}
.disabled-lkn{
    opacity: 0.4;
    pointer-events: none;
}
</style>
